import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";

import { useDispatch } from "react-redux";
import { logout } from "../store/userSlice";
import { useSelector } from "react-redux";

function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);

  const logOutUser = () => {
    dispatch(logout())
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        console.log("User signed out");
        navigate("/login");
      })
      .catch((error) => {
        console.error("Sign out error:", error);
      });
  };
  return (
    <header className="header js-header">
      <div className="menu">
        <div className="menu-background js-menu-background"></div>

        <div className="links">
          <a className="link js-link link-home " href="../index.html">
            <span className="highlight"></span>
            <span className="label">Home</span>
          </a>
          <a
            className="link js-link link-lessons "
            href="../lessons/introduction.html"
            data-router-disabled
          >
            <span className="highlight"></span>
            <span className="label">Lessons</span>
          </a>
          <span className="category">Community</span>
          <a
            className="link js-link link-challenges is-active"
            href="016-tamagotchi.html"
          >
            <span className="highlight"></span>
            <span className="label">Challenges</span>
          </a>
          <a
            className="link js-link link-selection "
            href="../selection/1.html"
          >
            <span className="highlight"></span>
            <span className="label">Selection</span>
          </a>
          <a
            className="link js-link link-highlights "
            href="../highlights/1.html"
          >
            <span className="highlight"></span>
            <span className="label">Highlights</span>
          </a>
        </div>

        {user ? (
          <>
            <nav className="actions is-desktop">
              <button
                type="button"
                className="logout-button"
                data-router-disabled=""
                onClick={() => {
                  logOutUser();
                }}
              >
                <span className="icon">
                  <svg
                    width="19"
                    height="20"
                    viewBox="0 0 19 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0 0H12V6H10V2H2V18H10V14H12V20H0V0ZM19 10L14 14V11H6V9H14V6L19 10Z"
                      fill="white"
                    ></path>
                  </svg>
                </span>
                <span className="label">Thoát</span>
              </button>
            </nav>
          </>
        ) : (
          <>
            <nav className="actions is-mobile">
              <a href="../login.html" className="login-button">
                <span className="icon">
                  <svg
                    width="15"
                    height="20"
                    viewBox="0 0 15 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.5 7C8.88071 7 10 5.88071 10 4.5C10 3.11929 8.88071 2 7.5 2C6.11929 2 5 3.11929 5 4.5C5 5.88071 6.11929 7 7.5 7ZM7.5 9C9.98528 9 12 6.98528 12 4.5C12 2.01472 9.98528 0 7.5 0C5.01472 0 3 2.01472 3 4.5C3 6.98528 5.01472 9 7.5 9Z"
                      fill="white"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.83255 12H6.11917C4.29393 12 2.71427 13.3055 2.3213 15.1388L1.9685 16.7847C1.83473 17.4088 2.29663 18 2.91797 18H12.0818C12.7142 18 13.1783 17.3888 13.0251 16.7577L12.6057 15.0308C12.1732 13.2497 10.6175 12 8.83255 12ZM6.11917 10C3.38131 10 1.01182 11.9583 0.42237 14.7082L0.0695708 16.3541C-0.331744 18.2263 1.05396 20 2.91797 20H12.0818C13.9791 20 15.3714 18.1664 14.9116 16.2731L14.4923 14.5462C13.8436 11.8745 11.5099 10 8.83255 10H6.11917Z"
                      fill="white"
                    />
                  </svg>
                </span>
                <span className="label">Đăng nhập</span>
              </a>


            </nav>
          </>
        )}
      </div>

      <div className="container">
        <nav className="navigation">
          <div className="logo-container">
            <a
              href="../index.html"
              className="main-logo is-abyss"
              name="Three.js Journey"
            >
              <div className="logo">
                <svg
                  width="38"
                  height="43"
                  viewBox="0 0 38 43"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.7346 0.971817L36.0112 18.4767C38.3367 19.8206 38.3368 23.1799 36.0115 24.5239L5.73423 42.0292C3.40538 43.3751 0.5 41.6914 0.5 39.0057V3.99513C0.5 1.31072 3.40451 -0.375901 5.7346 0.971817Z"
                    fill="#705DF2"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.772 9.44228L3.81036 15.2013C3.61917 15.3116 3.5 15.5166 3.5 15.7409V27.259C3.5 27.483 3.61986 27.6894 3.81109 27.7999L13.772 33.5593C13.9636 33.6701 14.2 33.6701 14.3916 33.5593L24.352 27.801C24.5445 27.6897 24.6636 27.4839 24.6636 27.2599V15.7418C24.6636 15.5177 24.5437 15.3114 24.3525 15.2009L14.3916 9.44228C14.2002 9.33183 13.9634 9.33183 13.772 9.44228Z"
                    fill="#705DF2"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.5 14.9575C0.5 13.6056 1.9625 12.7612 3.13325 13.4378L14.7031 20.1277C15.2562 20.4459 15.5814 21.0321 15.5814 21.6482V35.4708C15.5814 36.0069 15.2953 36.5022 14.831 36.7701C14.3666 37.038 13.7946 37.0377 13.3306 36.7694L1.38379 29.8619L1.37869 29.8589C0.825347 29.5407 0.5 28.9544 0.5 28.3382V14.9575ZM3.5 17.1153L12.5814 22.3663V32.8708L3.5 27.6201V17.1153Z"
                    fill="#705DF2"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24.7545 13.5966C26.0542 12.8459 27.6596 13.7907 27.6633 15.2724L27.6633 28.2328C27.6633 28.9247 27.2945 29.5654 26.6943 29.9121L15.4903 36.3896C14.1948 37.1379 12.5811 36.2001 12.5811 34.7103V21.7545C12.5811 21.0623 12.9502 20.4213 13.5509 20.0747L24.7545 13.5966ZM24.6633 17.1148L15.5811 22.3663V32.8718L24.6633 27.621V17.1148Z"
                    fill="#705DF2"
                  />
                </svg>
              </div>
              <div className="text"></div>
            </a>
          </div>

          <div className="links">
            {/* <a
              className="link js-link link-lessons "
              href="../lessons/introduction.html"
              data-router-disabled
            >
              <span className="highlight"></span>
              <span className="label">Lessons</span>
            </a> */}

            <a className="link js-link link-challenges is-active" href="/">
              <span className="highlight"></span>
              <span className="label">Tất cả khóa học</span>
            </a>

            <a className="link js-link link-selection " href="/pricing">
              <span className="highlight"></span>
              <span className="label">Gói thành viên</span>
            </a>

            {/* <a
              className="link js-link link-highlights "
              href="../highlights/1.html"
            >
              <span className="highlight"></span>
              <span className="label">Highlights</span>
            </a> */}
            <a
              className="link js-link link-challenges"
              href="/exchange"
            >
              <span className="highlight"></span>
              <span className="label">Quy đổi tiền</span>
            </a>
            <a
              className="link js-link link-challenges"
              href="/faq"
            >
              <span className="highlight"></span>
              <span className="label">Hỏi đáp</span>
            </a>
          </div>
        </nav>

        {user ? (
          <>
            <nav className="actions is-desktop">


              <a
                className="link js-link link-challenges mr-8 flex items-center"
                href="/account/mywallet"
              >
                <img id="avatarButton" type="button" data-dropdown-toggle="userDropdown" data-dropdown-placement="bottom-start" className="w-10 h-10 rounded-full cursor-pointer " src={user.avatar} alt="User dropdown" />
                <span className="label ml-2">Tài khoản</span>
                {/* <span className="label ml-2">Số dư: 200.000đ</span> */}
              </a>
              <button
                type="button"
                className="logout-button"
                onClick={() => {
                  logOutUser();
                }}
              >
                <span className="icon">
                  <svg
                    width="19"
                    height="20"
                    viewBox="0 0 19 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0 0H12V6H10V2H2V18H10V14H12V20H0V0ZM19 10L14 14V11H6V9H14V6L19 10Z"
                      fill="white"
                    ></path>
                  </svg>
                </span>
                <span className="label">Đăng xuất</span>
              </button>
            </nav>
          </>
        ) : (
          <>
            <nav className="actions is-desktop">

              <a href="/login" className="login-button">
                <span className="icon">
                  <svg
                    width="15"
                    height="20"
                    viewBox="0 0 15 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.5 7C8.88071 7 10 5.88071 10 4.5C10 3.11929 8.88071 2 7.5 2C6.11929 2 5 3.11929 5 4.5C5 5.88071 6.11929 7 7.5 7ZM7.5 9C9.98528 9 12 6.98528 12 4.5C12 2.01472 9.98528 0 7.5 0C5.01472 0 3 2.01472 3 4.5C3 6.98528 5.01472 9 7.5 9Z"
                      fill="white"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.83255 12H6.11917C4.29393 12 2.71427 13.3055 2.3213 15.1388L1.9685 16.7847C1.83473 17.4088 2.29663 18 2.91797 18H12.0818C12.7142 18 13.1783 17.3888 13.0251 16.7577L12.6057 15.0308C12.1732 13.2497 10.6175 12 8.83255 12ZM6.11917 10C3.38131 10 1.01182 11.9583 0.42237 14.7082L0.0695708 16.3541C-0.331744 18.2263 1.05396 20 2.91797 20H12.0818C13.9791 20 15.3714 18.1664 14.9116 16.2731L14.4923 14.5462C13.8436 11.8745 11.5099 10 8.83255 10H6.11917Z"
                      fill="white"
                    />
                  </svg>
                </span>
                <span className="label">Đăng nhập</span>
              </a>

            </nav>
          </>
        )}

        <button className="menu-trigger js-menu-trigger">
          <span className="bar bar-1"></span>
          <span className="bar bar-2"></span>
          <span className="bar bar-3"></span>
        </button>
      </div>
    </header>
  );
}

export default Header;
